import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { linkitApi, TOKEN_KEY } from "./api";

const AuthContext = createContext(null);

export function LinkitAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await linkitApi.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const applyAuth = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await linkitApi.post("/auth/login", { email, password });
    applyAuth(data);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await linkitApi.post("/auth/signup", payload);
    applyAuth(data);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, signup, logout, refresh: check, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useLinkitAuth = () => useContext(AuthContext);
